/**
 * Project Name to Config Key Mapping
 *
 * PURPOSE:
 * This map translates the actual project/folder name (as seen in apps/ directory)
 * to the configuration key used in AWS Secrets Manager.
 *
 * WHY NEEDED:
 * - Project folder names (e.g., 'c3-linear-monitoring') may differ from
 *   the Secrets Manager key names (e.g., 'c3')
 * - This allows us to maintain backward compatibility with existing secret names
 *   while using descriptive folder names for projects
 *
 * USAGE:
 * - Key   = Project folder name (matches apps/{folder-name} and project.json "name")
 * - Value = Secrets Manager config key (used to fetch from vcap-configs-{value})
 *
 * EXAMPLES:
 * - 'c3-linear-monitoring' → 'c3'           (local: /c3-linear-monitoring/config.json, secrets: vcap-configs-c3)
 * - 'library-manager'      → 'librarymanager' (local: /library-manager/config.json, secrets: vcap-configs-librarymanager)
 *
 * NOTE: If a project is not in this map, the project name itself is used as the config key.
 */
export const getMappedProject = {
    // Format: 'project-folder-name': 'secrets-config-key'
    'pitchnew-ui': 'pitchnew',
    'c3-linear-monitoring': 'c3',
    'central-repository': 'centralrepomam',
    'centralrepomam': 'centralrepomamnew',
    'library-manager': 'librarymanager',
    'operations-console': 'operationsconsole',
    'order-management-console': 'media-ingest-console',
    'orderManagementConsole': 'media-ingest-console',
    'partner-console': 'partner',
    'fulfillment': 'fulfillment',
    'libman': 'libman',
    'linear-console-2': 'linear-console',
    'linear-console-api-dev-ui': 'linear-console-api-dev-ui',
    'mip2': 'mip2',
    'ops-console-api-dev-ui': 'ops-console-api-dev-ui',
    'pr-paramountmsc': 'pr-paramountmsc',
    'qc-workbench': 'qc-workbench',
    'ragnarok': 'ragnarok',
    'chatbot': 'chatbot',
    'msc-fulfillment-performance': 'msc-fulfillment-performance'
};
/**
 * Gets the Secrets Manager config key for a given project name.
 * If no mapping exists, returns the project name as-is.
 *
 * @param projectName - The project folder name (e.g., 'c3-linear-monitoring')
 * @returns The Secrets Manager config key (e.g., 'c3')
 */
export function getConfigKeyForProject(projectName) {
    return getMappedProject[projectName] || projectName;
}
//# sourceMappingURL=projects-map.js.map